import './err.css'
const Error_404 = () => (
        <div className="error-wrap">
            <h1>Error 404</h1>
            <p>Ta strona nie istnieje</p>
        </div>
)


export default Error_404;